import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FileSharedSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FileSharedSVG;
